import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const blogsApi = createApi({
  reducerPath: 'blogsApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['blogs'],
  endpoints: (builder) => ({
    saveBlogDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.BlogController.saveBlogDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateBlogDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.BlogController.updateBlogDetail,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findBlogBySearch: builder.mutation({
      query(body) {
        return {
          url: spotFinder.BlogController.findBlogBySearch,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteBlogDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.BlogController.deleteBlogDetail}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    uploadImage: builder.mutation({
      query(body) {
        return {
          url: spotFinder.BlogController.uploadImage,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useSaveBlogDetailMutation,
  useUpdateBlogDetailMutation,
  useDeleteBlogDetailMutation,
  useFindBlogBySearchMutation,
  useUploadImageMutation,
} = blogsApi;
